/* AURIME QA + Conversion fixes (Claude) */
(function () {
  'use strict';

  var FREE_SHIP = 5900;
  var TP_URL = 'https://de.trustpilot.com/review/aurime.de';
  var CROSS_SELL = ['mini-zirkon-goz-kolye-925-gumus-1', 'dolphin-kupe-925-gumus', 'muttertag-geschenk-mom-halskette', 'sternzeichen-zirkonia-piercing'];
  var GIFT_WRAP_VARIANT = 55818722509185;
  var GIFT_WRAP_IMG = 'https://cdn.shopify.com/s/files/1/0923/2102/2337/files/Geschenkverpackung.webp?v=1781860034';

  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function eur(cents) { return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format((cents || 0) / 100); }

  function updateBubble() {
    return fetch(root() + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('#cart-bubble-text, [data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
        document.querySelectorAll('.cart-bubble').forEach(function (el) { if (cart.item_count > 0) el.removeAttribute('hidden'); });
        syncGiftWrap(cart);
        renderShipBar(cart);
      })
      .catch(function () {});
  }

  function refreshAndOpenDrawer() {
    var drawer = document.querySelector('cart-drawer-component');
    var items = document.querySelector('cart-items-component');
    if (!drawer || !items || !items.dataset.sectionId) { window.location.href = root() + 'cart'; return Promise.resolve(); }
    return fetch(root() + '?section_id=' + encodeURIComponent(items.dataset.sectionId))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('cart-items-component');
        if (fresh) items.innerHTML = fresh.innerHTML;
        var dlg = drawer.querySelector('.cart-drawer__dialog');
        if (dlg) dlg.classList.remove('cart-drawer--empty');
        refreshShipBar();
        if (typeof drawer.open === 'function') drawer.open();
        else { var t = document.querySelector('[data-testid="cart-drawer-trigger"]'); if (t) t.click(); }
      })
      .catch(function () { window.location.href = root() + 'cart'; });
  }

  function postAdd(body, isJson) {
    var headers = { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' };
    if (isJson) headers['Content-Type'] = 'application/json';
    return fetch(root() + 'cart/add.js', { method: 'POST', headers: headers, body: body })
      .then(async function (res) {
        var data = await res.json().catch(function () { return {}; });
        if (!res.ok) throw new Error(data.description || data.message || 'cart_error');
        return data;
      });
  }

  function changeLine(variantId, qty) {
    return fetch(root() + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: String(variantId), quantity: qty }) });
  }

  function addFromForm(form, btn, toCheckout) {
    if (!form || form.__aurimeAdding) return;
    if (btn && btn.disabled) return;
    form.__aurimeAdding = true;
    var label = null;
    if (btn) { label = btn.innerHTML; btn.disabled = true; btn.style.opacity = '0.6'; }
    postAdd(new FormData(form), false)
      .then(function () { if (toCheckout) { window.location.href = root() + 'checkout'; return; } return refreshAndOpenDrawer().then(updateBubble); })
      .catch(function (err) { console.error('[AURIME] add failed:', err); window.location.href = root() + (toCheckout ? 'checkout' : 'cart'); })
      .finally(function () { form.__aurimeAdding = false; if (btn && !toCheckout) { btn.disabled = false; btn.style.opacity = ''; if (label != null) btn.innerHTML = label; } });
  }

  function addVariant(variantId, btn) {
    if (!variantId || variantId === '0') return;
    if (btn && btn.__aurimeAdding) return;
    if (btn) { btn.__aurimeAdding = true; btn.disabled = true; btn.style.opacity = '0.6'; }
    postAdd(JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 }), true)
      .then(function () { return refreshAndOpenDrawer().then(updateBubble); })
      .catch(function (err) { console.error('[AURIME] add failed:', err); window.location.href = root() + 'cart'; })
      .finally(function () { if (btn) { btn.__aurimeAdding = false; btn.disabled = false; btn.style.opacity = ''; } });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('button') : null;
    if (!btn) return;
    var cls = String(btn.className || '');
    if (cls.indexOf('ai-add-to-cart-') !== -1) {
      var form = btn.closest('form');
      if (form && String(form.id).indexOf('ai-product-form-') === 0) { e.preventDefault(); e.stopImmediatePropagation(); addFromForm(form, btn, false); return; }
    }
    if (btn.id && btn.id.indexOf('ai-buy-now-') === 0) {
      var pform = document.querySelector('form[id^="ai-product-form-"]');
      if (pform) { e.preventDefault(); e.stopImmediatePropagation(); addFromForm(pform, btn, true); return; }
    }
    if (cls.indexOf('ai-collection-atc-btn-') !== -1) {
      if (btn.disabled) return;
      var card = btn.closest('[data-product-card]');
      var vid = btn.getAttribute('data-variant-id') || (card && card.getAttribute('data-selected-variant'));
      if (vid) { e.preventDefault(); e.stopImmediatePropagation(); addVariant(vid, btn); return; }
    }
    if (btn.classList && btn.classList.contains('aurime-xsell-add')) {
      e.preventDefault(); e.stopImmediatePropagation();
      addVariant(btn.getAttribute('data-variant-id'), btn);
    }
  }, true);

  document.addEventListener('change', function (e) {
    var el = e.target;
    if (!el) return;
    if (el.id === 'aurime-giftwrap-cb') {
      el.disabled = true;
      var done = function () { refreshAndOpenDrawer().then(updateBubble); };
      if (el.checked) postAdd(JSON.stringify({ id: GIFT_WRAP_VARIANT, quantity: 1 }), true).then(done).catch(done);
      else changeLine(GIFT_WRAP_VARIANT, 0).then(done).catch(done);
      return;
    }
    if (el.classList && el.classList.contains('aurime-gw-pp-cb')) {
      el.disabled = true;
      var fin = function () { el.disabled = false; updateBubble(); };
      if (el.checked) postAdd(JSON.stringify({ id: GIFT_WRAP_VARIANT, quantity: 1 }), true).then(fin).catch(fin);
      else changeLine(GIFT_WRAP_VARIANT, 0).then(fin).catch(fin);
      return;
    }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[id^="ai-product-form-"]')) return;
    e.preventDefault(); e.stopImmediatePropagation();
    addFromForm(form, form.querySelector('button[class*="ai-add-to-cart-"]'), false);
  }, true);

  var xsell = null, xsellTried = false;
  function loadCrossSell() {
    if (xsellTried) return Promise.resolve(xsell);
    xsellTried = true;
    var i = 0;
    function next() {
      if (i >= CROSS_SELL.length) return Promise.resolve(null);
      var handle = CROSS_SELL[i++];
      return fetch(root() + 'products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p) return next();
          var v = (p.variants || []).find(function (x) { return x.available; });
          if (!v) return next();
          xsell = { id: v.id, title: p.title, price: v.price, image: (p.featured_image || (p.images && p.images[0]) || ''), url: root() + 'products/' + p.handle };
          return xsell;
        })
        .catch(function () { return next(); });
    }
    return next();
  }

  function renderShipBar(cart) {
    /* Balken FEST oben im Drawer-Inhalt platzieren – über der scrollbaren
       Artikelliste, damit er nicht mit dem Produkt überlappt. */
    var content = document.querySelector('.cart-drawer__content');
    var itemsScroll = document.querySelector('.cart-drawer__items');
    var bar = document.getElementById('aurime-ship-bar');
    if (!bar) { bar = document.createElement('div'); bar.id = 'aurime-ship-bar'; }
    bar.style.flex = '0 0 auto';
    if (content && itemsScroll && itemsScroll.parentNode === content) {
      if (bar.parentNode !== content || bar.nextElementSibling !== itemsScroll) content.insertBefore(bar, itemsScroll);
    } else {
      var fb = itemsScroll || document.querySelector('.cart-drawer__inner');
      if (!fb) return;
      if (bar.parentNode !== fb) fb.insertBefore(bar, fb.firstChild);
    }
    var total = cart ? cart.total_price : 0;
    var remain = FREE_SHIP - total;
    var pct = Math.max(0, Math.min(100, Math.round(total * 100 / FREE_SHIP)));
    var msg;
    if (remain > 0) {
      msg = '<div class="aurime-ship-msg">Nur noch <strong>' + eur(remain) + '</strong> bis zum <strong>Gratisversand</strong></div><div class="aurime-ship-track"><span style="width:' + pct + '%"></span></div>';
    } else {
      msg = '<div class="aurime-ship-msg aurime-ship-done">Geschafft – du erhältst <strong>Gratisversand</strong>!</div><div class="aurime-ship-track"><span style="width:100%"></span></div>';
    }
    var gift = '';
    if (cart && cart.item_count > 0) {
      var checked = (cart.items || []).some(function (it) { return it.variant_id === GIFT_WRAP_VARIANT; });
      gift = '<label class="aurime-gift"><input type="checkbox" id="aurime-giftwrap-cb"' + (checked ? ' checked' : '') + '><span class="aurime-gift-txt">\uD83C\uDF81 Geschenkverpackung</span><span class="aurime-gift-price">+ ' + eur(390) + '</span></label>';
    }
    bar.innerHTML = '<div class="aurime-ship-inner">' + msg + '</div><div id="aurime-xsell-slot"></div>' + gift;
    if (remain > 0 && cart) {
      loadCrossSell().then(function (p) {
        if (!p) return;
        if ((cart.items || []).some(function (it) { return it.variant_id === p.id; })) return;
        var slot = document.getElementById('aurime-xsell-slot');
        if (!slot) return;
        slot.innerHTML = '<div class="aurime-xsell"><div class="aurime-xsell-hint">Füg das hinzu und sichere dir Gratisversand:</div><div class="aurime-xsell-row">' + (p.image ? '<img class="aurime-xsell-img" src="' + p.image + '" alt="" width="48" height="48">' : '') + '<div class="aurime-xsell-info"><a class="aurime-xsell-title" href="' + p.url + '">' + p.title + '</a><div class="aurime-xsell-price">' + eur(p.price) + '</div></div><button type="button" class="aurime-xsell-add" data-variant-id="' + p.id + '" aria-label="Hinzufügen">+</button></div></div>';
      });
    }
  }
  function refreshShipBar() { return fetch(root() + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(renderShipBar).catch(function () {}); }
  function watchCart() {
    var items = document.querySelector('cart-items-component');
    if (!items) return;
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(refreshShipBar, 250); }).observe(items, { childList: true, subtree: true });
  }

  function gwStyle() {
    if (document.getElementById('aurime-gw-style')) return;
    var s = document.createElement('style');
    s.id = 'aurime-gw-style';
    s.textContent = '.aurime-gw-pp{display:flex;align-items:center;gap:12px;margin:-8px 0 14px 0;padding:12px;border:1px solid #E6DFD3;border-radius:8px;background:#FBF7EF;font-family:var(--font-body--family,sans-serif)}.aurime-gw-pp-img{width:56px;height:56px;object-fit:cover;border-radius:6px;flex:none}.aurime-gw-pp-info{flex:1;min-width:0}.aurime-gw-pp-title{font-size:12px;font-weight:600;color:#2B241F;text-transform:uppercase;letter-spacing:.05em}.aurime-gw-pp-sub{font-size:12px;color:#8C7B6B;margin-top:3px}.aurime-gw-pp-toggle{display:inline-flex;align-items:center;gap:6px;flex:none;font-size:12px;color:#2B241F;cursor:pointer;white-space:nowrap}.aurime-gw-pp-toggle input{width:18px;height:18px;accent-color:#C9A84C;cursor:pointer}';
    document.head.appendChild(s);
  }
  function syncGiftWrap(cart) {
    var cb = document.querySelector('.aurime-gw-pp-cb');
    if (!cb) return;
    var inCart = (cart.items || []).some(function (it) { return it.variant_id === GIFT_WRAP_VARIANT; });
    if (cb.checked !== inCart) cb.checked = inCart;
    var lbl = document.querySelector('.aurime-gw-pp-toggle span');
    if (lbl) lbl.textContent = inCart ? 'Hinzugefügt' : 'Hinzufügen';
  }
  function injectGiftWrapPP() {
    if (document.getElementById('aurime-gw-pp')) return;
    var buy = document.querySelector('[id^="ai-buy-now-"]');
    var anchor = buy || document.querySelector('[class*="ai-quantity-cart-wrapper-"]');
    if (!anchor || !anchor.parentNode) return;
    gwStyle();
    var box = document.createElement('div');
    box.id = 'aurime-gw-pp';
    box.className = 'aurime-gw-pp';
    box.innerHTML = '<img class="aurime-gw-pp-img" src="' + GIFT_WRAP_IMG + '" alt="Geschenkverpackung" width="56" height="56" loading="lazy"><div class="aurime-gw-pp-info"><div class="aurime-gw-pp-title">Geschenkverpackung</div><div class="aurime-gw-pp-sub">Schön verpackt verschenken · ' + eur(390) + '</div></div><label class="aurime-gw-pp-toggle"><input type="checkbox" class="aurime-gw-pp-cb"><span>Hinzufügen</span></label>';
    anchor.parentNode.insertBefore(box, anchor.nextSibling);
    fetch(root() + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(syncGiftWrap).catch(function () {});
  }

  /* Google "Automatische Rabatte"-App-Block direkt unter den Preis schieben */
  function moveGoogleDiscount() {
    var info = document.querySelector('[class*="ai-product-info-"]');
    if (!info) return;
    var price = info.querySelector('[class*="ai-price-wrapper-"]');
    if (!price) return;
    var el = document.querySelector('[id*="automated_discounts_price"]');
    if (!el) return;
    if (info.contains(el)) return;
    el.style.margin = '4px 0 0 0';
    price.insertAdjacentElement('afterend', el);
  }

  function scrollToReviews() {
    var rev = document.querySelector('.jdgm-carousel, .jdgm-all-reviews, .jdgm-rev-widg, .jdgm-widget, [class*="judgeme"], [class*="judge-me"]');
    if (!rev) return;
    var y = rev.getBoundingClientRect().top + window.pageYOffset - 80;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }
  function starsAboveTitle() {
    var info = document.querySelector('[class*="ai-product-info-"]');
    if (!info) return;
    var title = info.querySelector('[class*="ai-product-title-"]');
    var rating = info.querySelector('[class*="ai-rating-"]');
    if (!title || !rating) return;
    info.insertBefore(rating, title);
    rating.style.cursor = 'pointer';
    rating.setAttribute('title', 'Zu den Bewertungen');
    rating.addEventListener('click', scrollToReviews);
  }

  function injectTrustpilot() {
    if (document.getElementById('aurime-trustpilot')) return;
    var cart = document.querySelector('cart-drawer-component');
    if (!cart || !cart.parentNode) return;
    var a = document.createElement('a');
    a.id = 'aurime-trustpilot';
    a.className = 'aurime-trustpilot';
    a.href = TP_URL; a.target = '_blank'; a.rel = 'noopener';
    a.setAttribute('aria-label', 'Bewertungen auf Trustpilot');
    a.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><path fill="#00B67A" d="M12 1.6l2.9 7.1 7.6.4-5.9 4.8 2 7.4L12 17l-6.6 4.3 2-7.4L1.5 9.1l7.6-.4z"/></svg><span>Trustpilot</span>';
    cart.parentNode.insertBefore(a, cart.nextSibling);
  }
  function watchHeader() {
    var hg = document.getElementById('header-group') || document.querySelector('header');
    if (!hg) return;
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(injectTrustpilot, 150); }).observe(hg, { childList: true, subtree: true });
  }

  function fixShippingLink() {
    document.querySelectorAll('[class*="ai-shipping-info-"] a').forEach(function (a) {
      var h = a.getAttribute('href');
      if (!h || h === '#') a.setAttribute('href', root() + 'pages/versand');
    });
  }

  var PAY = {
    'VISA': '<span class="aurime-pay"><span style="color:#1434CB;font:800 italic 11px/1 Arial,sans-serif;letter-spacing:-.5px">VISA</span></span>',
    'MASTERCARD': '<span class="aurime-pay"><span class="aurime-mc"><i></i><i></i></span></span>',
    'PAYPAL': '<span class="aurime-pay"><span style="font:800 10px/1 Arial,sans-serif"><span style="color:#003087">Pay</span><span style="color:#009CDE">Pal</span></span></span>',
    'KLARNA': '<span class="aurime-pay" style="background:#FFB3C7;border-color:#FFB3C7"><span style="color:#0B051D;font:700 10px/1 Arial,sans-serif">Klarna</span></span>',
    'APPLE PAY': '<span class="aurime-pay"><span style="font:600 9px/1 -apple-system,system-ui,Arial,sans-serif;color:#000">Apple\u00A0Pay</span></span>',
    'GOOGLE PAY': '<span class="aurime-pay"><span style="font:600 9px/1 Arial,sans-serif"><b style="color:#4285F4">G</b>\u00A0Pay</span></span>',
    'AMEX': '<span class="aurime-pay" style="background:#006FCF;border-color:#006FCF"><span style="color:#fff;font:700 9px/1 Arial,sans-serif">AMEX</span></span>',
    'SHOP PAY': '<span class="aurime-pay" style="background:#5A31F4;border-color:#5A31F4"><span style="color:#fff;font:700 9px/1 Arial,sans-serif">Shop\u00A0Pay</span></span>'
  };
  function swapPaymentBadges() {
    document.querySelectorAll('[class*="ai-payment-badges-"]').forEach(function (wrap) {
      wrap.querySelectorAll('[class*="ai-payment-pill-"]').forEach(function (pill) {
        var key = (pill.textContent || '').trim().toUpperCase();
        var html = PAY[key];
        if (!html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var node = tmp.firstChild;
        if (node) pill.replaceWith(node);
      });
    });
  }

  function init() {
    injectTrustpilot();
    watchHeader();
    starsAboveTitle();
    fixShippingLink();
    swapPaymentBadges();
    injectGiftWrapPP();
    moveGoogleDiscount();
    setTimeout(moveGoogleDiscount, 1200);
    setTimeout(moveGoogleDiscount, 3000);
    if (document.querySelector('cart-drawer-component')) { refreshShipBar(); watchCart(); }
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
